/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { PropsWithChildren } from "react";

import { Wrap } from "@components/elements";
import { css, cx } from "@panda/css";

import { TagAttributionStack, TagAttributionStackProps } from "./TagAttributionStack.atom";

const TagAttributionContainerStyles: string = css({
	display: "flex",
	position: "relative",
	alignItems: "center",
	justifyContent: "center",
	objectFit: "contain",
	h: "full",
	w: "full",
	"& > img, & > video": {
		maxHeight: "full",
		maxWidth: "full",
	},
});

export type CosmosTagsAndAttributionProps = PropsWithChildren<
	TagAttributionStackProps & {
		className?: string;
	}
>;

export const CosmosTagsAndAttribution = ({
	tags,
	attribution,
	className,
	children,
}: CosmosTagsAndAttributionProps): React.JSX.Element | null => {
	return (
		<Wrap
			condition={!!attribution || !!tags?.length}
			wrap={(children) => (
				<div className={cx("cosmos-tag-attribution-wrapper", TagAttributionContainerStyles, className)}>
					{children}
					<TagAttributionStack tags={tags} attribution={attribution} />
				</div>
			)}
		>
			{children}
		</Wrap>
	);
};
